import classnames from 'classnames';

import './ExpandIcon.css';

interface ExpandIconProps {
  className?: string;
  /** When true, rotates the caret to point up (collapse). */
  expanded?: boolean;
  size?: number;
}

/**
 * Filled caret used for table expand/collapse actions.
 * Distinct from ChevronIcon (stroke chevron used for navigation).
 */
function ExpandIcon({ className, expanded = false, size = 14 }: ExpandIconProps) {
  return (
    <svg
      aria-hidden='true'
      className={classnames('expand-icon', className, {
        'expand-icon--expanded': expanded,
      })}
      fill='none'
      focusable='false'
      height={size}
      role='img'
      viewBox='0 0 14 10'
      width={size}
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.28125 7.71875L1.28125 2.71875C0.875 2.34375 0.875 1.6875 1.28125 1.3125C1.65625 0.90625 2.3125 0.90625 2.6875 1.3125L7 5.59375L11.2812 1.3125C11.6562 0.90625 12.3125 0.90625 12.6875 1.3125C13.0938 1.6875 13.0938 2.34375 12.6875 2.71875L7.6875 7.71875C7.3125 8.125 6.65625 8.125 6.28125 7.71875Z'
        fill='currentColor'
      />
    </svg>
  );
}

export default ExpandIcon;
